import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';
import { AdminSettingFormValues, IAdminSetting } from '../models/AdminSetting';

const LIMIT = 10;

export default class AdminSettingStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.page = 0;
                this.AdminSettingRegistry.clear();
                this.loadAdminSettings();
            }
        )
    }

    AdminSettingRegistry = new Map();
    AdminSetting: IAdminSetting | null = null;
    loadingInitial = false;
    submitting = false;
    target = "";

    AdminSettingCount = 0;
    page = 0;

    predicate = new Map();

    setPredicate = (predicate: string, value: string | Date) => {
        this.predicate.clear();
        if (predicate !== 'My Notes') {
            this.predicate.set(predicate, value);
        } else {
            this.predicate.set('createdById', this.rootStore.userStore.user?.id)
        }
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('limit', String(LIMIT));
        params.append('offset', `${this.page ? this.page * LIMIT : 0}`);
        this.predicate.forEach((value, key) => {
            if (key === 'dateCreated') {
                params.append(key, value.toDateString());
            } else {
                params.append(key, value);
            }
        })
        return params;
    }

    get totalPages() {
        return Math.ceil(this.AdminSettingCount / LIMIT);
    }

    setPage = (page: number) => {
        this.page = page;
    }

    get AdminSettingsById() {
        return Array.from(this.AdminSettingRegistry.values()).sort(
            (a, b) => b.id - a.id
        );
    };

    loadAdminSettings = async () => {
        this.loadingInitial = true;
        try {
            const AdminSettingEnvelope = await agent.AdminSetting.list(this.axiosParams);
            const { adminSettingsDTO, adminSettingCount } = AdminSettingEnvelope;

            runInAction('loadAdminSettings', () => {
                adminSettingsDTO.forEach((adminSettingDTO) => {
                    this.AdminSettingRegistry.set(adminSettingDTO.id, adminSettingDTO);
                });
                this.AdminSettingCount = adminSettingCount;
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadAdminSettings', () => {
            this.loadingInitial = false;
        });
    };

    loadAdminSetting = async (id: string) => {
        let RequestNote = this.getAdminSetting(id);
        if (RequestNote) {
            this.AdminSetting = RequestNote;
            return RequestNote;
        }
        else {
            this.loadingInitial = true;
            try {
                RequestNote = await agent.RequestNotes.details(id);
                runInAction('getting activity', () => {
                    this.AdminSetting = RequestNote;
                    this.AdminSettingRegistry.set(RequestNote.id, RequestNote);
                    this.loadingInitial = false;
                })
                return RequestNote;
            } catch (error) {
                toast.error('problem submitting data');
            }
        }
        runInAction('loadRequestNotes', () => {
            this.loadingInitial = false;
        });
    };

    getAdminSetting = (id: string) => {
        return this.AdminSettingRegistry.get(id);
    }

    ClearAdminSetting = () => {
        this.AdminSetting = null;
    }

    createAdminSetting = async (adminSetting: AdminSettingFormValues) => {
        toast.error('Create Admin Setting not implemented');
    };

    editAdminSetting = async (adminSetting: AdminSettingFormValues) => {
        this.submitting = true;
        try {
            await agent.AdminSetting.update(adminSetting);
            runInAction('edit admin setting', () => {
                this.submitting = false;
            });
            toast.success('Saved Admin Setting');
            this.AdminSettingRegistry.set(adminSetting.id, adminSetting)
            this.rootStore.modalStore.closeModal();
        } catch (error) {
            runInAction('edit admin setting', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };



}
decorate(AdminSettingStore, {
    AdminSettingRegistry: observable,
    AdminSetting: observable,
    loadingInitial: observable,
    submitting: observable,
    target: observable,
    AdminSettingCount: observable,
    page: observable,
    predicate: observable,

    loadAdminSetting: action,
    loadAdminSettings: action,
    ClearAdminSetting: action,
    setPredicate: action,
    setPage: action,
    createAdminSetting: action,
    editAdminSetting: action,

    AdminSettingsById: computed,
    axiosParams: computed,
    totalPages: computed
});